// extracted by mini-css-extract-plugin
export default {"cellAlign":"cellAlign---h7iP5","authorityIcon":"authorityIcon---ndyW3"};